import React from 'react';
import { Form, Input, Select } from '@rocketseat/unform';
import fileDownload from 'js-file-download';
import { Container, Report } from './styles';
import api from '~/services/api';

function Reports() {
  async function handleSubmitPaymentsReport(data) {
    if (data.type === 'ALL') {
      data.type = undefined;
    }
    try {
      const response = await api.get(
        'payment/report',
        {
          params: data,
        },
        {
          responseType: 'blob',
        }
      );
      fileDownload(response.data, `report.csv`);
    } catch (err) {
      console.log(err);
    }
  }
  async function handleSubmitChargesReport(data) {
    try {
      const response = await api.get(
        'charge/report',
        {
          params: data,
        },
        {
          responseType: 'blob',
        }
      );
      fileDownload(response.data, `chargeReport.csv`);
    } catch (err) {
      console.log(err);
    }
  }  async function handleSubmitClientsReport() {
    try {
      const response = await api.get(
        'report/client',
        {
          responseType: 'blob',
        }
      );
      fileDownload(response.data, `clientsReport.csv`);
    } catch (err) {
      console.log(err);
    }
  }
  async function handleSubmitVehiclesReport(data) {
    try {
      let params = {};
      if (data.type === 'YES') {
        params = { ...params, subscribed: true };
      } else if (data.type === 'NO') {
        params = { ...params, subscribed: false };
      }
      const response = await api.get(
        'vehicle/report',
        {
          params,
        },
        {
          responseType: 'blob',
        }
      );
      fileDownload(response.data, `vehiclesReport.csv`);
    } catch (err) {
      console.log(err);
    }
  }
  return (
    <Container>
      <Report>
        <h1> Payments </h1>
        <Form onSubmit={handleSubmitPaymentsReport}>
          <Input label="Start Date" type="date" name="start" />
          <Input label="End Date" type="date" name="end" />
          <Select
            label="Payment Method"
            name="type"
            options={[
              { id: 'ALL', title: 'ALL' },
              { id: 'CASH', title: 'CASH' },
              { id: 'DEBIT_CARD', title: 'DEBIT CARD' },
              { id: 'REFERRAL', title: 'REFERRAL' },
              { id: 'DEBIT_CARD_SEB', title: 'DEBIT CARD (SEB)' },
              { id: 'WIRE', title: 'WIRE' },
              { id: 'CHECK', title: 'CHECK' },
            ]}
          />

          <button type="submit">Generate</button>
        </Form>
      </Report>
      <Report>
        <h1> Complete Charges (Taxes) </h1>
        <Form onSubmit={handleSubmitChargesReport}>
          <Input label="Start Date" type="date" name="start" />
          <Input label="End Date" type="date" name="end" />
          <button type="submit">Generate</button>
        </Form>
      </Report>
      <Report>
        <h1> Vehicles </h1>
        <Form onSubmit={handleSubmitVehiclesReport}>
          <Select
            label="Subscribed"
            name="type"
            options={[
              { id: 'YES', title: 'Yes' },
              { id: 'NO', title: 'No' },
              { id: 'BOTH', title: 'Both' },
            ]}
          />
          <button type="submit">Generate</button>
        </Form>
      </Report>
      <Report>
        <h1> Clients</h1>
        <Form onSubmit={handleSubmitClientsReport}>
          <button type="submit">Generate</button>
        </Form>
      </Report>
    </Container>
  );
}

export default Reports;
